import { CustomerSummary } from "@contracts/pages";

export const customCollabThemeTypes = Object.freeze(["localBusiness", "event", "photoShoot", "creatorProposal"] as const);
export type CustomCollabThemeType = null | (typeof customCollabThemeTypes)[number];

export enum CustomCollabStatuses {
  // See CustomCollabStatuses.cs for a full list
  PreparingDeliverables = "preparing-deliverables",
  DeliverablesReady = "deliverables-ready",
}

export interface CustomCollabCustomerTemplate {
  templateId: string;
  themeId: CustomCollabThemeType;
  title: string;
  icon: string;
  description: string;
  messageText: string;
}

export interface CustomCollabClientPayload {
  creator: CustomCollabCreatorSummary;
  customer: CustomerSummary;

  customerCollabInputs: CustomCollabCustomerData;
  creatorCollabInputs: CustomCollabCreatorData;

  statusCreatorText: string;
  statusCustomerText: string;

  creatorStatusOptions: Record<string, string>;
}

export interface CustomCollabClientSummary {
  customCollabId: string;
  title: string;

  // todo: Just the fields the widgets need (tbd)
  // Whether we share this between customer and creator depends on what the widgets need

  creator: any;
  customer: any;
}

export interface CustomCollabCreatorSummary {
  creatorName: string;
  creatorProfileImage: string;
}

export interface CustomCollabCustomerData {
  id: string;
  _etag: string;
  customerId: string;
  creatorId: string;

  messageThreadId: string;

  title: string;
  purpose: string;
  deliverables: string;
  paymentAmount: number;
  otherComp: Array<string>;
  activityDate: string | null;
  dueDate: string | null;
  otherNotes: string;
  contactEmail: string;

  formalizedDate: string | null;
  markedCompleteDate: string | null;

  creatorMarkedPaid: boolean;
  archivedDate: string | null;

  createdDate: string;
  createdBy: string;
  updatedDate: string;
  updatedBy: string;
}

export interface CustomCollabCreatorData {
  id: string;

  customerId: string;
  creatorId: string;

  customCollabId: string;
  messageThreadId: string;

  agreedToDate: string | null;

  status: string;
  deliverables: Array<string>;
  deliverablesReadyDate: string | null;
  creatorNotes: string;

  invite: CustomCollabCreatorInvite;

  createdDate: string;
  createdBy: string;
  updatedDate: string;
  updatedBy: string;
}

export interface CustomCollabCreatorInvite {
  invitedEmail: string;
  inviteKey: string;
}

export interface NewCustomCollabPayload {
  creatorId?: string;
  invitedCreatorEmail?: string;
  initialMessage: string;
  templateId: string;
}

export interface CustomCollabWidgetPayload {
  creatorId: string;
  communityId: string;
  entityName: string; // Customer or Creator name
  entityId: string; // CustomerId or CreatorId
  entityPhotoUrl: string; // "https://dev-cdn.shrpa.com/cms/images/profiles/4cf39ebb-8ae8-4da5-847b-6f4e5f12a2ca.jpg";
  customCollabId: string;
  title: string;
  dueDate: string | null;
  activityDate: string | null;
  statusText: string; // "Preparing Deliverables"
  statusCode: string; // "preparing-deliverables"
  creatorAgreed: boolean;
  markedCompleteDate: boolean;
  lastMessageText?: string;
  lastMessageDate?: string;
  creatorNotes?: string | null;
  totalMessageCount: number;
  unreadMessageCount: number | null;
  activeOrRecentlyCompleted: boolean;
}
